<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer ref="modal-create-update-file"
            @hidden="resetModal">

            <div class="container wrap-form-create-update-chapter">
                <h4>
                    <strong>{{ getNameTitle }}</strong>
                </h4>
                <b-form id="form-create-update-chapter" @submit.prevent="handleSave">
                    <div class="row form-group pb-2">
                        <div class="col-md-12">
                            <div class="login-modal__form__item display-block">
                                <label for="name">Tên tài liệu:</label>
                                <b-form-input id="name" v-model="form.name" type="text" placeholder="Nhập tên tài liệu"
                                    autocomplete="off" class="form-control" />
                                <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.name.required && submitted">
                                    Vui lòng nhập tên tài liệu
                                </span>
                            </div>
                        </div>
                    </div>
                    <div v-if="this.fileId==0" class="row form-group pb-2">
                        <div class="col-md-12">
                            <input
                                    hidden
                                    type="file"
                                    name="file"
                                    id="fileInputUpload"
                                    class="hidden-input"
                                    @change="onChangeUploadFile"
                                    ref="file"
                                    accept=".pptx,.docx,.xlsx,.pdf,.h5p"
                                />
                            <div v-if="!(form.file || form.fileName)" class="login-modal__form__item display-block">
                                <div 
                                @dragover="dragoverUploadFile"
                                @dragleave="dragleaveUploadFile"
                                @drop="dropUploadFile"
                                class="wrap-upload-file display-flex justify-content-space-between"
                                :class="isDragging?'upload-drag':''"
                                >
                               
                                    <div class="upload-file-left">
                                        <img class="icon-upload" src="@/assets/img/upload.png" />
                                    </div>
                                    <div class="upload-file-center">
                                        <div><strong>Thêm hoặc kéo thả</strong></div>
                                        <div>
                                            Hỗ trợ các định dạng .pptx, .docx, .xlsx, .pdf
                                        </div>
                                        <div>
                                            Mỗi lần chỉ tải 1 file, dung lượng file không vượt quá 15MB
                                        </div>
                                    </div>
                                    <div class="upload-file-right">
                                        <button 
                                        @click="onUploadFile"
                                        type="button"
                                            class="btn btn-upload border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1">
                                            CHỌN FILE
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <span class="error display-block color-err font-size-14 text-left"
                                    v-if="!$v.form.fileName.required && submitted">
                                    Vui lòng nhập tên tài liệu
                                </span>
                            <div v-else-if="(form.file || form.fileName)" class="display-block">
                                <label for="name">File bài giảng:</label>
                                <div class="wrap-file-data display-flex justify-content-space-between">
                                    
                                    <div class="wrap-left display-flex">
                                        <img class="icon-photo" src="@/assets/img/photo.png" />
                                        <div class="name-file">
                                            {{ form.fileName }}
                                        </div>
                                    </div>
                                    <div class="wrap-right display-flex">
                                        <div class="size-file">{{ formatSizeFile(form.sizeFile) }}</div>
                                        <img @click="handleOnRemoveFile" class="btn-delete" src="@/assets/img/icon-close.png" />
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>

                    <div class="form_action display-flex justity-content-space-between">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>
                        <button type="submit"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading || form.typeDocument == ''">
                            {{ fileId>0?'Cập nhật':'Thêm mới' }}
                        </button>
                    </div>
                </b-form>
            </div>

        </b-modal>
    </div>
</template>
<script>
import { required,requiredIf } from 'vuelidate/lib/validators';
import { saveFileClassSchool, getDetail } from './../../../_api/fileClassSchoolServices'
export default{
    props:{
        fileId:{
            type:Number,
            default:0
        },
        type:{
            type:Number,
            default:0
        }
    },
    data(){
        return{
            confirmActive: {},
            submitted: false,
            isLoading: false,
            form: {
                id: 0,
                lessonClassSchoolId: 0,
                name: '',
                fileName:'',
                path: '',
                sizeFile:0,
                type:this.type,
                file:null//lưu trữ file upload
            },
            isDragging: false,
        }
    },
    mounted() {
        this.form.lessonClassSchoolId = this.$route.query.id
        if (this.fileId > 0) {
            //get detail
            this.getDetailFileClassSchool()
        }
        this.handleShowModal()
    },
    computed:{
        getNameTitle(){
            return this.fileId>0?'Cập nhật tên tài liệu':'Thêm tài liệu'
        }
    },
    validations() {
        return {
            form: {
                name: {
                    required
                },
                fileName:{ 
                    required
                }
            }
        }
    },
    methods:{
        getDetailFileClassSchool(){
            let self = this
            getDetail(this.fileId).then(res => {
                if (res && res.data && !res.errors) {
                    this.form= {
                        id: res.data.id,
                        lessonClassSchoolId:res.data.lessonClassSchoolId,
                        name: res.data.name,
                        fileName:res.data.fileName,
                        path: res.data.path,
                        sizeFile:res.data.sizeFile,
                        type:res.data.sizeFile,
                        file:null//lưu trữ file upload
                    }
                }
            })
        },
        onUploadFile(){
            this.$refs.file.click()
        },
        onChangeUploadFile(){
            this.form.file = this.$refs.file.files[0]
            this.form.sizeFile = this.form.file.size
            this.form.fileName= this.form.file.name
        },
        dropUploadFile(e){
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChangeUploadFile();
            this.isDragging = false;
        },
        dragoverUploadFile(e){
            e.preventDefault();
            this.isDragging = true;
        },
        dragleaveUploadFile(){
            this.isDragging = false;
        },
        handleSave(){
            let self = this
            this.submitted = true
            if (!this.$v.$invalid) {
            //     form: {
            //     id: 0,
            //     lessonClassSchoolId: 0,
            //     name: '',
            //     fileName:'',
            //     path: '',
            //     sizeFile:0,
            //     file:null//lưu trữ file upload
            // },
                const formData = new FormData();
                formData.append('id', this.form.id);
                formData.append('lessonClassSchoolId', this.form.lessonClassSchoolId);
                formData.append('name', this.form.name);
                formData.append('file', this.form.file);
                formData.append('type', this.form.type);
                saveFileClassSchool(formData).then(res => {
                    if (res && res.data && !res.errors) {
                        if (this.form.id > 0) {
                            self.$toast.success('Cập nhật tên tài liệu thành công')
                        } else {
                            self.$toast.success('Thêm mới tên tài liệu thành công')
                        }
                        self.handleDone()
                    }
                })
            }
        },
        handleOnRemoveFile(){
            this.$refs.file.value = '';
            this.form.file = null
            this.form.path = ''
            this.form.fileName=''
        },
        formatSizeFile(data, to='MB') { 
            const const_term = 1024; 
        
            // Convert the values and concatenate 
            // the appropriate unit 
            if (to === "KB") { 
                return (data / const_term).toFixed(3) + "KB"; 
            } else if (to === "MB") { 
                return (data / const_term ** 2).toFixed(3) + "MB"; 
            } else if (to === "GB") { 
                return (data / const_term ** 3).toFixed(3) + "GB"; 
            } else if (to === "TB") { 
                return (data / const_term ** 4).toFixed(3) + "TB"; 
            } else { 
                return ""; 
            } 
        }, 
        resetModal() {
            this.submitted = false
            this.form = {
                id: 0,
                lessonClassSchoolId: 0,
                name: '',
                fileName:'',
                path: '',
                sizeFile:0,
                type:this.type,
                file:null//lưu trữ file upload
            }
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-create-update-file'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-create-update-file'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-create-update-file'].show()
        },
    }
}
</script>
<style lang="scss" scoped>
.upload-drag{
    border: 2px dashed #46b5e1 !important;
    opacity: 0.5;
}
.wrap-file-data{
    .wrap-left{
        .name-file{
            max-width: 285px;
            text-overflow: ellipsis;
            overflow: hidden;
            margin-left: 5px;
        }
        .icon-photo{
            width: 30px;
        }
    }
    .wrap-right{
        .size-file{
            margin-right: 5px;
            color: #7a7777;
        }
        .btn-delete{
            cursor: pointer;
            width: 20px;
            height: 20px;
        }
    }
}
.wrap-upload-file {
    border: 1px dashed #c8c8c8;
    padding: 10px;
    border-radius: 15px;
    .upload-file-left {
        min-width: 50px;

        .icon-upload {
            width: 30px;
        }
    }

    .upload-file-right {
        .btn-upload {
            background: white;
            border: 2px solid #59b7df;
            color: #59b7df;
            min-width: 110px;
        }
    }
}

.wrap-input {
    margin-left: 10px;
    width: 75%;
}

.wrap-form-create-update-chapter {
    background-color: white;
}

.justify-content-space-between {
    justify-content: space-between
}
</style>
